// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_ydD","cls2":"ReferenceReportPage-cls2_T5p ReferenceReportPage-cls1_ydD"};